module.exports = __webpack_public_path__ + "static/media/ilya-yakover.35c69567.jpg";